import { useSubscription } from "@apollo/client";
import { UNCOMPLETED_TASKS_NUMBER_SUBSCRIPTION } from "@/modules/common/widgets/notification-bell/api/uncompleted-tasks-number-subscription";

export function useUncompletedTasksNumber() {
  const { data } = useSubscription(UNCOMPLETED_TASKS_NUMBER_SUBSCRIPTION);

  return {
    uncompletedTasksNumber: data?.personTasksUncompletedCountSubscription ?? 0,
  };
}
